import React, { useState, useEffect } from "react"
import styled from "@emotion/styled"
import { injectIntl } from "gatsby-plugin-intl"
import { isBrowser } from "../../../context/ApolloContext"
import { useLocation } from "@reach/router"

const RotatingStickyBannerWrapper = styled.div`
  width: 100%;
  padding: 8px 20px;
  font-size: 18px;
  text-align: center;
  background: ${props => props.theme.saleColor.bgColor};
  color: ${props => props.theme.saleColor.textColor};
  position: relative;
  overflow: hidden;
  min-height: 53px;
  display: flex;

  @media (max-width: 720px) {
    min-height: 50px;
  }

  @media (max-width: 480px) {
    min-height: 44px;
  }

  @media (max-width: 450px) {
    padding: 8px 10px;
  }

  @media (max-width: 350px) {
    min-height: 40px;
  }
`

const Container = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 0px auto;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
`

const TextBoxWrapper = styled.div`
  width: 100%;
  min-height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 3;

  .movetext {
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    animation-duration: 8s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    z-index: 9;
  }

  .firstbox {
    -webkit-animation-name: first-message;
    animation-name: first-message;
  }
  .secondbox {
    -webkit-animation-name: second-message;
    animation-name: second-message;
    opacity: 0;
  }

  @keyframes first-message {
    0%,
    45% {
      transform: translateY(0);
      opacity: 1;
    }
    50%,
    95% {
      transform: translateY(-40px);
      opacity: 0;
    }
    100% {
      transform: translateY(40px);
      opacity: 0;
    }
  }

  @keyframes second-message {
    0%,
    45% {
      transform: translateY(40px);
      opacity: 0;
    }
    50%,
    95% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(-40px);
      opacity: 0;
    }
  }
`

const TextBox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-family: "Museo";
  font-weight: 400;
  font-size: 21px;
  line-height: 1.2;
  color: ${props => props.theme.saleColor.textColor};
  text-align: left;
`

const LeftText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "Gotham";
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  margin: 0px 15px 0px 0px;

  span {
    font-family: "Gotham Book";
    font-weight: 500;
    letter-spacing: 1.5px;

    @media (max-width: 400px) {
      letter-spacing: 1.5px;
    }
  }

  @media (max-width: 400px) {
    font-size: 16px;
  }

  @media (max-width: 340px) {
    margin: 0px 10px 0px 0px;
  }
`

const RightText = styled.div`
  font-family: "Gotham Book";
  font-weight: 500;
  font-size: 18px;
  line-height: 1;
  text-align: center;

  strong {
    font-weight: 900;
  }

  span:nth-of-type(2) {
    @media (max-width: 600px) {
      display: block;
    }
  }

  @media (max-width: 400px) {
    font-size: 16px;
  }

  @media (max-width: 360px) {
    font-size: 14px;
  }
`

const RotatingStickyBanner = ({ intl }) => {
  const [isChaisePage, setisChaisePage] = useState(false)

  const { pathname } = useLocation()

  const checkButtonVisibility = () => {
    let currentPath = ""
    let chaiseRegex = /(chaise-bureau-ergonomique|chaise-gaming)/

    currentPath = window.location.pathname

    setisChaisePage(chaiseRegex.test(currentPath))
  }

  useEffect(() => {
    isBrowser && checkButtonVisibility()
  }, [pathname])
  return (
    <RotatingStickyBannerWrapper className="LyneHomeStickyBanner">
      <Container>
        {isChaisePage ? (
          <TextBox>
            <LeftText>
              OFFRE D’HIVER <span>Derniers jours</span>
            </LeftText>
            <RightText>
              <strong>-100€</strong> sur la chaise
            </RightText>
          </TextBox>
        ) : (
          <TextBoxWrapper>
            <TextBox className="firstbox movetext">
              <LeftText>
                OFFRE D’HIVER <span>Derniers jours</span>
              </LeftText>
              <RightText>
                <span>
                  <strong>-25% sur tout le site</strong>{" "}
                </span>
                <span>dès 150€ d’achat</span>
              </RightText>
            </TextBox>
            <TextBox className="secondbox movetext">
              <LeftText>
                OFFRE D’HIVER <span>Derniers jours</span>
              </LeftText>
              <RightText>
                <span>
                  <strong>-50%</strong>{" "}
                </span>
                <span>
                  sur le 2<sup>e</sup> <span>T-shirt</span>
                </span>
              </RightText>
            </TextBox>
          </TextBoxWrapper>
        )}
      </Container>
    </RotatingStickyBannerWrapper>
  )
}

export default injectIntl(RotatingStickyBanner)
